import { useContext, useEffect, useRef, useState } from "react";
import TopArea from "./TopArea";
import BottomArea from "./BottomArea";
import { DataContext } from "./DataProvider";
const Magicpen = () => {
    const infoRef = useRef();
    const { viewPosition, height1, setHeight1, height2, setHeight2 } = useContext(DataContext);
    const [mousedown, setMouseDown] = useState(false);
    const [startPos, setStartPos] = useState(0);

    // styles start
    const divStyle = {
        width: "100%",
        height: "calc(100vh - 60px)",
        // height: "calc(100svh - 60px)",
        display: "flex",
        flexDirection: viewPosition ? "row" : "column",
    }
    const moveBox = {
        width: viewPosition ? "15px" : "100%",
        height: viewPosition ? "100%" : "15px",
        background: "black",
        cursor: viewPosition ? "col-resize" : "row-resize",
    };
    // styles end
    const handleMouseDown = (event) => {
        setMouseDown(true);
        setStartPos(viewPosition ? event.clientX : event.clientY);
    }


    useEffect(() => {
        const html = document.getElementById("html");
        const css = document.getElementById("css");
        const js = document.getElementById("js");
        const pos = viewPosition ? Math.round(Math.abs(infoRef.current.getBoundingClientRect().left - startPos)) : Math.round(Math.abs(infoRef.current.getBoundingClientRect().top - startPos));
        const handleMouseUp = (event) => {
            setTimeout(() => {
                setMouseDown(false);
            }, 10);
        };

        const handleDocumentmove = (event) => {
            html.style.transition = "0s";
            css.style.transition = "0s";
            js.style.transition = "0s";
            if (!viewPosition) {
                if (mousedown && event.clientY > 132 && event.clientY < window.innerHeight - 50) {
                    setHeight1(event.clientY - pos);
                    setHeight2(height2 + startPos - event.clientY);
                }
            } else {
                if (mousedown && event.clientX > 50 && event.clientX < window.innerWidth - 50) {
                    setHeight1(event.clientX - pos);
                    setHeight2(height2 + (startPos + pos) - event.clientX);
                }
            }
        };

        if (mousedown === true) {
            document.addEventListener("mousemove", handleDocumentmove);
            document.addEventListener("mouseup", handleMouseUp);
        }
        return () => {
            document.removeEventListener("mousemove", handleDocumentmove);
            document.removeEventListener("mouseup", handleMouseUp);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mousedown]);

    return (
        <div style={divStyle}>
            <TopArea cHeight={height1} />
            <div ref={infoRef} style={moveBox} onMouseDownCapture={handleMouseDown} ></div>
            <BottomArea cHeight={height2} startPos={startPos} mousekey={mousedown} />
        </div>
    );
}

export default Magicpen;